import { state, actions } from '@/store';

export default (authGuard, guestGuard) => [
    ...guestGuard([
        {
            path: '/login',
            name: 'login',
            meta: { layout: 'fullscreen' },
            component: () => import('@/pages/login')
        }
    ]),

    ...authGuard([
        {
            path: '/',
            name: 'root',
            redirect: { name:'home' }
        },
        {
            path: '/home',
            name: 'home',
            meta: { layout: 'fullscreen' },
            component: () => import('@/pages/home')
        },
        {
            path: '/retail',
            name: 'retail',
            meta: { layout: 'fullscreen' },
            component: () => import('@/pages/retail')
        },
        {
            path: '/stock',
            name: 'stock',
            meta: { layout: 'fullscreen' },
            component: () => import('@/pages/stock')
        },
        {
            path: '/sales',
            name: 'sales',
            meta: { layout: 'fullscreen' },
            component: () => import('@/pages/sales')
        }
    ]),
];